import { render, staticRenderFns } from "./ExpertGride.vue?vue&type=template&id=8e84b5a4&scoped=true&"
import script from "./ExpertGride.vue?vue&type=script&lang=js&"
export * from "./ExpertGride.vue?vue&type=script&lang=js&"
import style0 from "./ExpertGride.vue?vue&type=style&index=0&id=8e84b5a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e84b5a4",
  null
  
)

export default component.exports